import Icon from '../components/Icon.vue'

Icon.register({
  signature: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M623.2 192C571.4 195.5 497.5 246.7 460.1 263.5 431 276.6 405.9 287.9 384 287.9 361.4 287.9 358 271.7 362.7 236 363.8 228 374.4 156.8 320 159.9 294.9 161.4 255.7 184.7 150.5 285.9L192 182.2C222.4 106.3 138.8 30.7 62.3 79.4L7.4 116.3C0 121-2.2 130.9 2.5 138.4L19.7 165.4C24.4 172.9 34.3 175.1 41.8 170.3L99.8 131.4C118.2 119.7 140.5 138.6 132.5 158.5L34.3 404.1C27.5 421 37 448 64 448 72.3 448 80.5 444.8 86.6 438.6 128.8 396.4 241.3 287.9 297.8 242.8 295.6 271.3 295.7 301.7 318.4 326.6 333.7 343.4 355.7 351.9 383.9 351.9 419.5 351.9 451.9 337.3 486.2 321.9 519.2 307.1 585.2 259.3 624.6 256.1 633.1 255.4 639.8 248.8 639.8 240.3V208.2C640 199.1 632.3 191.4 623.2 192z'
      }
    ]
  }
})
